import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorAction, csColorBackground, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseBreadcrumbItem   = {
  currentColor: css`var(--cse-breadcrumb-item-current-color, ${csColorText.muted})`,
  backgroundColor: css`var(--cse-breadcrumb-item-background-color, ${csColorBackground.primary})`,
  backgroundColorHover: css`var(--cse-breadcrumb-item-background-color-hover, ${csColorBackground.info})`,
  borderRadius: css`var(--cse-breadcrumb-item-border-radius, ${csBorder.radiusFull})`,
  color: css`var(--cse-breadcrumb-item-color, ${csColorText.body})`, 
  colorHover: css`var(--cse-breadcrumb-item-color-hover, ${csColorAction.linkPrimaryHover})`, 
  paddingInline: css`var(--cse-breadcrumb-item-padding-x, ${csSpacing.spacing05})`, 
  paddingBlock: css`var(--cse-breadcrumb-item-padding-y, ${csSpacing.spacing03})`,
}

export const style: CSSResult = css`
  .cse-breadcrumb-item {
    --cse-text-color: ${cseBreadcrumbItem.color};

    align-items: center;
    background-color: ${cseBreadcrumbItem.backgroundColor};
    border-radius: ${cseBreadcrumbItem.borderRadius};
    color: ${cseBreadcrumbItem.color};
    column-gap: ${csSpacing.spacing04};
    display: flex;
    padding-block: ${cseBreadcrumbItem.paddingBlock};
    padding-inline: ${cseBreadcrumbItem.paddingInline};
    text-decoration: none;
  }

  .cse-breadcrumb-item:hover {
    --cse-text-color: ${cseBreadcrumbItem.colorHover};
    background-color: ${cseBreadcrumbItem.backgroundColorHover};
    color: ${cseBreadcrumbItem.colorHover};
  }

  .variant-current {
    user-select: none;
  }

  .variant-current,
  .variant-current:hover {
    --cse-text-color: ${cseBreadcrumbItem.currentColor};
    background-color: ${cseBreadcrumbItem.backgroundColor};
    color: ${cseBreadcrumbItem.currentColor};
  }
`
